module.exports = "data:text/x-markdown;base64,Q29uZ3JhdHMhIEluc3BpcmVkIGJ5OiBbV2FycEZpbmFuY2UgSGFja10oaHR0cHM6Ly9zbG93bWlzdC5tZWRpdW0uY29tL2FuYWx5c2lzLW9mLXdhcnAtZmluYW5jZS1oYWNrZWQtaW5jaWRlbnQtY2IxMmExYWY3NGNjKS4K"


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/fakerdao_complete.md
// module id = 1832
// module chunks = 0